module.exports = __webpack_public_path__ + "static/media/mi.e4464213.png";